 import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  CalendarDaysIcon,
  CheckCircleIcon,
  ClipboardDocumentCheckIcon,
  DocumentTextIcon,
  UserGroupIcon,
  ClipboardDocumentListIcon,
  CameraIcon,
  XMarkIcon,
  BellIcon,
  AcademicCapIcon,
  ChevronRightIcon,
  ClockIcon,
  TrashIcon,
  ExclamationTriangleIcon,
  ArrowRightOnRectangleIcon,
  HomeIcon,
  WalletIcon,
  HeartIcon,
  FolderIcon,
  ChartBarIcon,
  ShieldCheckIcon,
  LifebuoyIcon,
  CurrencyDollarIcon,
  UserIcon,
  CalendarIcon,
  WrenchScrewdriverIcon,
  UsersIcon,
  PresentationChartLineIcon,
} from "@heroicons/react/24/outline";

// API Services Import
import { 
  getDashboardStats, 
  // getEmployeeHeaderSafe, 
  getEmployeeDashboard, 
  getManagerDashboard, 
  getAdminDashboard 
} from "../services/dashboard.service";
import { applyLeave } from "../services/employee.service";
import { getUpcomingHolidays } from "../services/employee.service";
import { getUpcomingEvents } from "../services/employee.service";
import {
  getAttendanceSummary,
  getWeeklySummary,
  getMyExceptions,
  getEmployeeHeaderSafe,
  employeePayslipAPI
} from "../services/employee.service";
import MyRequests from "../components/MyRequests";




/* ------------------------------------- HELPER COMPONENTS ------------------------------------- */
const ActionRow = ({ icon, title, tag, onClick }) => (
  <div onClick={onClick} className="flex items-center justify-between p-2 rounded-xl hover:bg-slate-50 transition cursor-pointer group border border-transparent hover:border-slate-100">
    <div className="flex items-center gap-2">
      <div className="w-7 h-7 rounded-lg bg-[#EDF4FF] text-[#4A90E2] flex items-center justify-center group-hover:bg-[#4A90E2] group-hover:text-white transition-colors">
        {React.cloneElement(icon, { className: "w-3.5 h-3.5" })}
      </div>
      <span className="text-xs font-semibold text-slate-700">{title}</span>
    </div>
    <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded-md ${tag === 'Critical' ? 'text-red-600 bg-red-50' : 'text-amber-600 bg-amber-50'}`}>
      {tag}
    </span>
  </div>
);

const EventItem = ({ title, time, badge }) => (
  <div className="p-4 rounded-xl bg-[#0F172A] border border-slate-800 transition group hover:border-[#4A90E2]/50">
    <div className="flex justify-between items-start gap-3">
      <div className="min-w-0">
        <p className="text-sm font-semibold text-white font-['Poppins'] truncate mb-1">{title}</p>
        <div className="flex items-center gap-1.5 mb-3">
          <ClockIcon className="w-3 h-3 text-slate-400" />
          <p className="text-[10px] text-slate-400 font-['Roboto']">{time}</p>
        </div>
        <div className="flex -space-x-2">
          <img className="w-6 h-6 rounded-full border-2 border-[#0F172A] object-cover" src="https://i.pravatar.cc/150?u=11" alt="user" />
          <img className="w-6 h-6 rounded-full border-2 border-[#0F172A] object-cover" src="https://i.pravatar.cc/150?u=12" alt="user" />
          <img className="w-6 h-6 rounded-full border-2 border-[#0F172A] object-cover" src="https://i.pravatar.cc/150?u=13" alt="user" />
          <div className="w-6 h-6 rounded-full border-2 border-[#0F172A] bg-slate-700 flex items-center justify-center">
            <span className="text-[8px] font-bold text-white">+2</span>
          </div>
        </div>
      </div>
      {badge && (
        <span className="text-[8px] font-black uppercase tracking-tighter text-white bg-red-600/80 px-1.5 py-0.5 rounded">Critical</span>
      )}
    </div>
  </div>
);

const GlobeAltIconPlaceholder = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
  </svg>
);

/* ------------------------------------- COMPACT TILE COMPONENT (for Manager Tools) ------------------------------------- */
const CompactTile = ({ icon, title, iconColor, onClick, subtitle }) => (
  <div
    onClick={onClick}
    className="cursor-pointer bg-white p-5 rounded-2xl border border-[#D8E3F0] shadow-sm hover:shadow-md hover:border-[#4A90E2]/40 transition-all group"
  >
    <div className="flex items-center gap-4">
      <div className={`${iconColor} p-3 bg-[#EDF4FF] rounded-xl group-hover:bg-[#4A90E2]/10 transition-colors`}>
        {React.cloneElement(icon, { className: "w-6 h-6" })}
      </div>
      <div className="flex-1">
        <h3 className="text-base font-bold text-slate-900 group-hover:text-[#4A90E2] transition-colors">
          {title}
        </h3>
        <p className="text-xs text-slate-500 mt-1">{subtitle}</p>
      </div>
      <ChevronRightIcon className="w-5 h-5 text-slate-400 group-hover:text-[#4A90E2] transition-colors" />
    </div>
  </div>
);

/* ------------------------------------- MAIN COMPONENT ------------------------------------- */
export default function EmployeeDashboard() {
  console.log('DASHBOARD: Component loaded');
  
  const navigate = useNavigate();
  const location = useLocation();
  const notificationRef = useRef(null);
const [upcomingHoliday, setUpcomingHoliday] = useState(null);
const [upcomingEvents, setUpcomingEvents] = useState([]);

const [attendanceSummary, setAttendanceSummary] = useState({
  present: 0,
  absent: 0,
  leave: 0,
  wfh: 0
});

  // --- Integration States ---
  const [userName, setUserName] = useState("Loading...");
  const [role, setRole] = useState(localStorage.getItem("role") || "employee");
  const [headerData, setHeaderData] = useState(null);

  // Role flags
  const isEmployee = ['employee', 'junior_employee', 'senior_employee'].includes(role);
  const isReportingManager = role === 'reporting_manager';
  const isManager = ['manager', 'reporting_manager'].includes(role);
  const isHROrAdmin = ['hr', 'admin'].includes(role);
  const isTeamLead = role === 'team_lead';
  const isFinance = role === 'finance';
  const isTactical = role === 'tactical';
  const [stats, setStats] = useState({ total: 0, present: 0, leave: 0 });
  const [loading, setLoading] = useState(true);

  const [profileImage, setProfileImage] = useState(localStorage.getItem("userProfileImage") || "https://images.unsplash.com/photo-1560250097-0b93528c311a");
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);

  // Fetch notifications from API
  useEffect(() => {
    console.log('DASHBOARD: useEffect for notifications started');
    
    const empCode = localStorage.getItem("emp_code");
    const role = localStorage.getItem("role");
    
    console.log('DASHBOARD NOTIFICATIONS: empCode:', empCode, 'role:', role);
    
    if (!empCode || empCode === "N/A") {
      console.log('DASHBOARD NOTIFICATIONS: No valid empCode, exiting');
      return;
    }

    // Fetch unified notifications from the new endpoint
    fetch(`/unified_approval/notifications/my?emp_code=${empCode}&limit=20`)
      .then(res => res.json())
      .then(data => {
        const formattedNotifications = data.map(notification => {
          let formattedTime = 'Invalid date';
          try {
            const date = new Date(notification.created_at);
            if (!isNaN(date.getTime())) {
              formattedTime = date.toLocaleString();
            }
          } catch (error) {
            console.error('Date parsing error:', error);
          }
          
          return {
            ...notification,
            time: formattedTime
          };
        });
        setNotifications(formattedNotifications);
      })
      .catch(err => {
        console.error("Failed to fetch unified notifications:", err);
        setNotifications([]);
      });

    // Fetch offboarding notifications
    fetch(`/offboarding/notifications/${empCode}`)
      .then(res => res.json())
      .then(data => {
        if (data.notifications && data.notifications.length > 0) {
          const offboardingNotifications = data.notifications.map(notification => ({
            id: `offboarding_${notification.id}`,
            title: notification.title,
            message: notification.message,
            time: new Date(notification.created_at).toLocaleString(),
            read: notification.read,
            priority: notification.priority,
            type: 'offboarding'
          }));
          setNotifications(prev => [...offboardingNotifications, ...prev]);
        }
      })
      .catch(err => {
        console.error("Failed to fetch offboarding notifications:", err);
      });

    // Fetch payslip notifications
    employeePayslipAPI.getMyPayslips()
      .then(response => {
        if (response.data.success && response.data.data.length > 0) {
          const latestPayslip = response.data.data[0];
          const payslipNotification = {
            id: `payslip_${latestPayslip.month}`,
            title: 'New Payslip Available',
            message: `Your payslip for ${latestPayslip.month_name} is now available for download`,
            time: new Date(latestPayslip.generated_at).toLocaleString(),
            read: false,
            priority: 'medium',
            type: 'payslip_generated',
            data: {
              month: latestPayslip.month,
              net_pay: latestPayslip.net_pay,
              gross_pay: latestPayslip.gross_pay
            }
          };
          setNotifications(prev => [payslipNotification, ...prev]);
        }
      })
      .catch(err => {
        console.error("Failed to fetch payslip notifications:", err);
      });

    // Fetch tracking alerts if user is a manager
    if (role && role.toLowerCase() === 'manager') {
      console.log('DASHBOARD NOTIFICATIONS: Fetching tracking alerts for manager:', empCode);
      
      fetch(`/tracking/manager/${empCode}/tracking-alerts`)
        .then(res => {
          console.log('DASHBOARD NOTIFICATIONS: Tracking alerts response status:', res.status);
          return res.json();
        })
        .then(data => {
          console.log('DASHBOARD NOTIFICATIONS: Tracking alerts response:', data);
          
          if (data.alerts && data.alerts.length > 0) {
            const trackingNotifications = data.alerts.map(alert => ({
              id: `tracking_${alert.id}`,
              title: 'Employee Tracking Alert',
              message: alert.message,
              time: new Date(alert.created_at).toLocaleString(),
              read: alert.is_read,
              priority: alert.priority,
              type: 'tracking_alert'
            }));
            console.log('DASHBOARD NOTIFICATIONS: Adding tracking notifications:', trackingNotifications);
            setNotifications(prev => [...trackingNotifications, ...prev]);
          } else {
            console.log('DASHBOARD NOTIFICATIONS: No tracking alerts found');
          }
        })
        .catch(err => {
          console.error("Failed to fetch tracking alerts:", err);
        });
    }
  }, []);

  const [leaveModal, setLeaveModal] = useState(false);
  const [correctionModal, setCorrectionModal] = useState(false);
  const [leaveType, setLeaveType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [leaveReason, setLeaveReason] = useState("");
  const [leaveSuccess, setLeaveSuccess] = useState(false);
  const [leaveValidationError, setLeaveValidationError] = useState("");

 // --------------------
// ATTENDANCE DASHBOARD STATES (REAL DATA ONLY)
// --------------------


const [weeklyAttendance, setWeeklyAttendance] = useState([]);
const [attendanceExceptions, setAttendanceExceptions] = useState([]);

// --------------------
// DASHBOARD DATA FETCH
// --------------------
useEffect(() => {
  const fetchAllData = async () => {
    try {
      setLoading(true);

      console.log("DASHBOARD FETCH START");

      // 1️⃣ ROLE
      const rawStoredRole = localStorage.getItem("role") || "employee";
      const cleanRole = rawStoredRole.toLowerCase().trim();
      setRole(cleanRole);

      // 2️⃣ EMP CODE + DATE
      const empCode = localStorage.getItem("emp_code");
      const today = new Date();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();

      console.log("EMP CODE:", empCode);
      console.log("MONTH:", month, "YEAR:", year);

      // 3️⃣ HEADER + STATS
      const baseResults = await Promise.allSettled([
        getEmployeeHeaderSafe(),
        getDashboardStats(),
      ]);

      const hRes =
        baseResults[0].status === "fulfilled" ? baseResults[0].value : null;
      const sData =
        baseResults[1].status === "fulfilled" ? baseResults[1].value : null;

      if (hRes && (hRes.data || hRes)) {
        const actualData = hRes.data || hRes;
        setHeaderData(actualData);
        setUserName(actualData.full_name || "User");
      }

      if (sData) {
        setStats({
          total: sData.totalEmployees?.total_employees || 0,
          present: sData.presentToday?.present_count || 0,
          leave: sData.onLeave?.on_leave_count || 0,
        });
      }

      // 4️⃣ HOLIDAYS
      try {
        const holidayRes = await getUpcomingHolidays();
        let holidays = [];
        
        if (Array.isArray(holidayRes?.data)) {
          holidays = holidayRes.data;
        } else if (Array.isArray(holidayRes)) {
          holidays = holidayRes;
        } else if (holidayRes?.data?.holidays) {
          holidays = holidayRes.data.holidays;
        }
        
        if (holidays.length > 0) {
          const nextHoliday = holidays[0];
          setUpcomingHoliday({
            title: nextHoliday.title,
            date: new Date(nextHoliday.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
          });
        } else {
          setUpcomingHoliday(null);
        }
      } catch (err) {
        console.error('Holiday fetch error:', err);
        setUpcomingHoliday(null);
      }

      // ✅ 5️⃣ UPCOMING EVENTS (FIXED — OLD LOGIC RESTORED)
      try {
        console.log("CALLING UPCOMING EVENTS");
        const eventsRes = await getUpcomingEvents();

        const events =
          Array.isArray(eventsRes?.data)
            ? eventsRes.data
            : Array.isArray(eventsRes)
            ? eventsRes
            : [];

        setUpcomingEvents(events);
      } catch (err) {
        console.error("Upcoming Events Error:", err);
        setUpcomingEvents([]);
      }

      // 6️⃣ ATTENDANCE (unchanged)
      if (empCode) {
        const attendanceResults = await Promise.allSettled([
          getAttendanceSummary({ emp_code: empCode, month, year }),
          getWeeklySummary({ emp_code: empCode }),
          getMyExceptions({ emp_code: empCode }),
        ]);

        if (attendanceResults[0].status === "fulfilled") {
          const response = attendanceResults[0].value;
          // Handle both {data: {...}} and direct {...} response formats
          const d = response?.data || response || {};

          setAttendanceSummary({
            present: d.present || 0,
            absent: d.absent || 0,
            leave: d.leave || 0,
            wfh: d.wfh || 0,
          });
        }

         

        if (attendanceResults[1].status === "fulfilled") {
          setWeeklyAttendance(attendanceResults[1].value?.data || []);
        }

        if (attendanceResults[2].status === "fulfilled") {
          setAttendanceExceptions(attendanceResults[2].value?.data || []);
        }
      } else {
        console.warn("EMP CODE MISSING — ATTENDANCE CALL SKIPPED");
      }

      // 7️⃣ ROLE DASHBOARD
      if (['admin', 'hr'].includes(cleanRole)) {
        await getAdminDashboard();
      } else if (cleanRole === 'manager') {
        await getManagerDashboard();
      } else {
        await getEmployeeDashboard();
      }

      console.log("DASHBOARD FETCH COMPLETE");
    } catch (error) {
      console.error("Dashboard Integration Error:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchAllData();
}, [location.pathname]);


// --------------------
// ATTENDANCE % CALCULATIONS (REAL)
// --------------------
const totalAttendanceDays =
  attendanceSummary.present +
  attendanceSummary.absent +
  attendanceSummary.leave +
  attendanceSummary.wfh;

const presentPct = totalAttendanceDays
  ? (attendanceSummary.present / totalAttendanceDays) * 100
  : 0;

const absentPct = totalAttendanceDays
  ? (attendanceSummary.absent / totalAttendanceDays) * 100
  : 0;

const leavePct = totalAttendanceDays
  ? (attendanceSummary.leave / totalAttendanceDays) * 100
  : 0;

const wfhPct = totalAttendanceDays
  ? (attendanceSummary.wfh / totalAttendanceDays) * 100
  : 0;


// --------------------
// NOTIFICATIONS
// --------------------
const clearNotifications = () => {
  setNotifications([]);
  setShowNotifications(false);
};

// Test function to manually fetch tracking alerts
const testFetchAlerts = async () => {
  const empCode = localStorage.getItem("emp_code");
  console.log('TEST: Fetching alerts for manager:', empCode);
  
  try {
    const response = await fetch(`/tracking/manager/${empCode}/tracking-alerts`);
    const data = await response.json();
    console.log('TEST: Response:', data);
    
    if (data.alerts && data.alerts.length > 0) {
      const trackingNotifications = data.alerts.map(alert => ({
        id: `tracking_${alert.id}`,
        text: alert.message,
        time: new Date(alert.created_at).toLocaleString(),
        read: alert.is_read,
        priority: alert.priority
      }));
      setNotifications(prev => [...trackingNotifications, ...prev]);
      alert(`Found ${data.alerts.length} tracking alerts!`);
    } else {
      alert('No tracking alerts found');
    }
  } catch (error) {
    console.error('TEST: Error:', error);
    alert('Error fetching alerts: ' + error.message);
  }
};

// --------------------
// LEAVE SUBMIT
// --------------------
const handleLeaveSubmit = async () => {
  setLeaveValidationError("");
  const today = new Date().toISOString().split("T")[0];

  if (!leaveType || !fromDate || !toDate || !leaveReason.trim()) {
    setLeaveValidationError("Please fill all fields including reason.");
    return;
  }

  if (fromDate < today) {
    setLeaveValidationError("Start date cannot be in the past.");
    return;
  }

  if (toDate < fromDate) {
    setLeaveValidationError("End date cannot be earlier than start date.");
    return;
  }

  const leaveTypeMap = {
    "Sick Leave": "SL",
    "Casual Leave": "CL",
    "Paid Leave": "AL",
    "Optional Leave": "OL",
  };

  try {
    await applyLeave({
      leave_type_code: leaveTypeMap[leaveType],
      from_date: fromDate,
      to_date: toDate,
      reason: leaveReason,
    });

    setLeaveSuccess(true);
    setTimeout(() => {
      setLeaveModal(false);
      setCorrectionModal(false);
      setLeaveSuccess(false);
      setLeaveType("");
      setFromDate("");
      setToDate("");
      setLeaveReason("");
    }, 1500);
  } catch (error) {
    console.error("Leave Apply Error:", error);
    setLeaveValidationError("Failed to submit leave. Please try again.");
  }
};


  const handleImageUpload = e => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileImage(imageUrl);
      localStorage.setItem("userProfileImage", imageUrl);
      window.dispatchEvent(new Event("storage"));
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  // Helper for Real Calendar
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const currentDate = today.getDate();
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();

  return (
    
    <div className="flex min-h-screen bg-[#F0F7FF] font-sans" style={{ fontFamily: "'Poppins', 'Roboto', sans-serif" }}>
      
      <main className="flex-1 min-h-screen overflow-y-auto">
<header className="px-6 py-4 flex justify-between items-center border-b border-[#D8E3F0] bg-white/50 backdrop-blur-md sticky top-0 z-50">
<div>
<h1 className="text-xl font-bold text-slate-900">Welcome back, {userName}</h1>
<p className="text-sm text-slate-600">
{today.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: '2-digit', year: 'numeric' })}
</p>
</div>
<div className="flex items-center gap-4 relative" ref={notificationRef}>
<div
onClick={() => setShowNotifications(!showNotifications)}
className="p-2 cursor-pointer text-[#4A90E2] hover:bg-[#EDF4FF] rounded-lg transition-colors relative"
>
<BellIcon className="w-5 h-5" />
{notifications.some(n => !n.read) && (
<span className="absolute top-1.5 right-1.5 w-2 h-2 bg-[#F2994A] rounded-full border-2 border-white"></span>
)}
</div>

  <button
    onClick={handleLogout}
    className="p-2 cursor-pointer text-slate-500 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors"
  >
    <ArrowRightOnRectangleIcon className="w-5 h-5" />
  </button>

  {showNotifications && (
    <div className="absolute right-0 top-12 w-80 bg-white rounded-xl shadow-xl border border-[#D8E3F0] z-[60]">
      <div className="p-3 border-b border-[#D8E3F0] flex justify-between items-center bg-[#EDF4FF]">
        <h4 className="text-sm font-bold text-slate-800">Notifications</h4>
        <div className="flex gap-2">
          {role === 'manager' && (
            <button onClick={testFetchAlerts} className="text-xs text-blue-600 font-medium hover:underline">
              Test Alerts
            </button>
          )}
          <button onClick={clearNotifications} className="text-xs text-[#F2994A] font-medium hover:underline">
            Clear All
          </button>
        </div>
      </div>
      <div className="max-h-64 overflow-y-auto">
        {notifications.map(n => (
          <div key={n.id} className={`p-3 border-b border-[#D8E3F0] last:border-none hover:bg-[#EDF4FF] transition ${
            n.priority === 'high' ? 'bg-red-50' : ''
          }`}>
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  {n.type === 'payslip_generated' && (
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  )}
                  {n.type === 'tracking_alert' && (
                    <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  )}
                  {n.type === 'offboarding' && (
                    <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                  )}
                  <h4 className="text-sm font-semibold text-slate-800">{n.title || 'Notification'}</h4>
                </div>
                <p className="text-sm text-slate-800 font-medium">{n.message || n.text}</p>
                <p className="text-xs text-slate-500 mt-1">{n.time}</p>
                {n.priority === 'high' && (
                  <span className="text-xs text-red-600 font-bold mt-1 block">HIGH PRIORITY</span>
                )}
                {n.type === 'payslip_generated' && n.data && (
                  <div className="mt-2 text-xs text-green-600">
                    <span>Net Pay: ₹{n.data.net_pay?.toLocaleString('en-IN') || '0'}</span>
                  </div>
                )}
                {n.type === 'offboarding' && (
                  <div className="mt-2 text-xs text-red-600 font-medium">
                    <span>🚪 Resignation Process</span>
                  </div>
                )}
              </div>
              {!n.read && (
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-1"></div>
              )}
            </div>
          </div>
        ))}
        {notifications.length === 0 && (
          <div className="p-4 text-center text-sm text-slate-500">
            No notifications
          </div>
        )}
      </div>
    </div>
  )}
</div>

</header>

<div className="p-6 space-y-6">
<div className="flex flex-col lg:flex-row gap-6 items-stretch">

  {/* 1. PROFILE CARD */}
  <div className="flex-1 bg-white rounded-2xl border border-[#D8E3F0] shadow-sm p-6 flex gap-8 items-center min-h-[300px]">
    <div className="relative shrink-0">
      <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-[#F0F7FF] shadow-sm">
        <img
          src={profileImage}
          alt="profile"
          className="w-full h-full object-cover"
        />
      </div>
      <label className="absolute bottom-1 right-1 bg-[#4A90E2] p-2 rounded-full cursor-pointer shadow-lg hover:bg-[#357ABD] transition border-2 border-white">
        <CameraIcon className="w-4 h-4 text-white" />
        <input type="file" hidden onChange={handleImageUpload} />
      </label>
    </div>

    <div className="flex-1 min-w-0">
      <div className="flex items-center justify-between mb-1">
        <h2
          onClick={() => navigate("/dashboard/MyProfile")}
          className="text-2xl font-bold text-slate-900 cursor-pointer hover:text-[#4A90E2] transition truncate"
        >
          {userName}
        </h2>
        <span className="text-[10px] font-bold text-emerald-600 bg-emerald-50 px-2.5 py-1 rounded-full border border-emerald-100 uppercase tracking-wider">
          {headerData?.status || "Active"}
        </span>
      </div>
      <p className="text-sm font-medium text-slate-500 mb-4">{headerData?.designation || "Senior Developer"}</p>

      <div className="flex items-center gap-6 py-4 border-y border-slate-50">
        <div className="flex flex-col">
          <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-0.5">Employee ID</span>
          <span className="text-sm font-semibold text-slate-700">{headerData?.employee_code || "N/A"}</span>
        </div>
        <div className="w-px h-8 bg-slate-100"></div>
        <div className="flex flex-col">
          <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-0.5">Joined</span>
          <span className="text-sm font-semibold text-slate-700">{headerData?.date_of_joining || "N/A"}</span>
        </div>
      </div>

      <div className="flex gap-4 mt-4">
        <a href="#" className="text-[#1877F2] transition transform hover:scale-110">
          <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
        </a>
        <a href="#" className="text-[#0A66C2] transition transform hover:scale-110">
          <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
        </a>
        <a href="#" className="text-slate-400 transition transform hover:scale-110">
          <GlobeAltIconPlaceholder />
        </a>
      </div>
    </div>
  </div>

  {/* 2. CALENDAR CARD */}
  <div className="flex-1 bg-white rounded-2xl border border-[#D8E3F0] p-4 shadow-sm flex flex-col justify-between min-h-[300px]">
    <div className="flex items-center gap-2 mb-3">
      <CalendarIcon className="w-5 h-5 text-[#4A90E2]" />
      <h3 className="text-sm font-bold text-slate-900 font-['Poppins']">Calendar</h3>
    </div>
    <div className="mb-2">
      <div className="grid grid-cols-7 gap-1 text-center text-[10px] font-bold text-slate-400 mb-1">
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(day => (
          <span key={day}>{day}</span>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1 text-center">
        {Array.from({ length: 42 }).map((_, i) => {
          const dayNum = i - firstDayOfMonth + 1;
          const isToday = dayNum === currentDate && new Date().getMonth() === currentMonth;
          const isValidDay = dayNum > 0 && dayNum <= daysInMonth;
          return (
            <div
              key={i}
              className={`aspect-square flex items-center justify-center text-[10px] rounded-md transition ${isToday
                ? 'bg-[#4A90E2] text-white font-bold'
                : isValidDay
                  ? 'text-slate-700 hover:bg-[#EDF4FF]'
                  : 'text-transparent'
                }`}
            >
              {isValidDay ? dayNum : ''}
            </div>
          );
        })}
      </div>
    </div>
    <div className="flex gap-2 mt-2">
      <button
        onClick={() => setLeaveModal(true)}
        className="flex-1 py-1.5 bg-orange-500 text-white rounded-lg text-[10px] font-bold hover:bg-orange-600 transition"
      >
        Request
      </button>
      <button
        onClick={() => setCorrectionModal(true)}
        className="flex-1 py-1.5 bg-black text-white rounded-lg text-[10px] font-bold hover:bg-gray-800 transition"
      >
        Correct
      </button>
    </div>
  </div>

  {/* 3. UPCOMING EVENTS CARD */}
  <div className="flex-1 bg-white rounded-2xl border border-[#D8E3F0] p-5 shadow-sm flex flex-col h-[300px] overflow-hidden">
    <h3 className="text-sm font-bold text-slate-900 mb-4 font-['Poppins'] shrink-0">Upcoming Events</h3>
    <div className="relative flex-1 overflow-hidden">
      <style>
        {`
          @keyframes scrollUp {
            0% { transform: translateY(0); }
            100% { transform: translateY(-50%); }
          }
          .animate-scroll {
            animation: scrollUp 15s linear infinite;
          }
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}
      </style>
      <div className="animate-scroll space-y-3">
        {upcomingEvents.length > 0 ? (
          upcomingEvents.map((event) => (
            <EventItem
              key={event.portal_id}
              title={event.title}
              time={`${event.day} ${event.month}`}
              badge={false}
            />
          ))
        ) : (
          <div className="text-center text-sm text-slate-500 py-10">
            No upcoming events
          </div>
        )}
      </div>
    </div>
  </div>
</div>

<div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
  <div className="bg-white rounded-2xl border border-[#D8E3F0] p-5 shadow-sm hover:shadow-md transition-shadow">

    {/* HEADER */}
    <div className="flex items-center justify-between mb-3">
      <h3 className="text-base font-bold text-slate-900">
        Attendance Statistics
      </h3>
      <ClockIcon className="w-5 h-5 text-[#4A90E2]" />
    </div>

    {/* CONTENT */}
    <div className="flex flex-col items-center">

      {/* CIRCLE */}
      <div className="relative w-32 h-32 mb-4">
        <svg
          width="128"
          height="128"
          viewBox="0 0 128 128"
          className="transform -rotate-90"
        >
          <circle
            cx="64"
            cy="64"
            r="56"
            fill="none"
            stroke="#f3f4f6"
            strokeWidth="16"
          />
          <circle
            cx="64"
            cy="64"
            r="56"
            fill="none"
            stroke="#10b981"
            strokeWidth="16"
            strokeDasharray={(presentPct * 1.76) + " 176"}
          />
          <circle
            cx="64"
            cy="64"
            r="56"
            fill="none"
            stroke="#ef4444"
            strokeWidth="16"
            strokeDasharray={(absentPct * 1.76) + " 176"}
            strokeDashoffset={-(presentPct * 1.76)}
          />
          <circle
            cx="64"
            cy="64"
            r="56"
            fill="none"
            stroke="#fbbf24"
            strokeWidth="16"
            strokeDasharray={(leavePct * 1.76) + " 176"}
            strokeDashoffset={-((presentPct + absentPct) * 1.76)}
          />
          <circle
            cx="64"
            cy="64"
            r="56"
            fill="none"
            stroke="#8b5cf6"
            strokeWidth="16"
            strokeDasharray={(wfhPct * 1.76) + " 176"}
            strokeDashoffset={-((presentPct + absentPct + leavePct) * 1.76)}
          />
        </svg>

        {/* CENTER TEXT */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-2xl font-bold text-slate-900">
            {attendanceSummary.present}
          </span>
          <span className="text-xs text-slate-600">days</span>
        </div>
      </div>

      {/* STATS GRID */}
      <div className="grid grid-cols-2 gap-4 w-full text-center text-xs">
        <div>
          <p className="text-lg font-bold text-green-600">
            {attendanceSummary.present} days
          </p>
          <p className="text-slate-600">Present</p>
        </div>

        <div>
          <p className="text-lg font-bold text-red-600">
            {attendanceSummary.absent} days
          </p>
          <p className="text-slate-600">Absent</p>
        </div>

        <div>
          <p className="text-lg font-bold text-amber-500">
            {attendanceSummary.leave} days
          </p>
          <p className="text-slate-600">On Leave</p>
        </div>

        <div>
          <p className="text-lg font-bold text-indigo-600">
            {attendanceSummary.wfh} days
          </p>
          <p className="text-slate-600">WFH</p>
        </div>
      </div>
    </div>
  </div>

  <div className="space-y-2">
    <div className="bg-white rounded-2xl border border-[#D8E3F0] px-3 py-2 shadow-sm self-start">
      <h4 className="text-[10px] font-bold text-slate-600 uppercase tracking-wider mb-2">
        Required Actions
      </h4>
      <div className="space-y-0.5">
        <ActionRow
          icon={<DocumentTextIcon />}
          title="Timesheet Review"
          tag="Critical"
          onClick={() => navigate("/dashboard/WorkStatus")}
        />
        <ActionRow
          icon={<ClipboardDocumentCheckIcon />}
          title="Performance Check"
          tag="Pending"
          onClick={() => navigate("/dashboard/performance-review")}
        />
      </div>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="bg-white rounded-2xl border border-[#D8E3F0] p-4 shadow-sm flex items-center justify-between">
        <div>
          <h4 className="text-[10px] font-bold text-slate-500 uppercase">Upcoming Holiday</h4>
          <p className="text-sm font-bold text-slate-900 mt-1">
            {upcomingHoliday
              ? `${upcomingHoliday.date} - ${upcomingHoliday.title}`
              : "No upcoming holidays"}
          </p>
        </div>
        <CalendarDaysIcon className="w-5 h-5 text-orange-500" />
      </div>
      <div
        onClick={() => navigate("/dashboard/pay")}
        className="bg-green-50 rounded-2xl p-4 shadow-sm flex items-center justify-between cursor-pointer border border-green-200 hover:bg-green-100 transition-colors"
      >
        <div>
          <h4 className="text-[10px] font-bold text-green-600 uppercase">Payslip</h4>
          <p className="text-sm font-bold text-slate-900 mt-1">View Payslips</p>
        </div>
        <CurrencyDollarIcon className="w-5 h-5 text-green-600" />
      </div>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
      <div
        onClick={() => navigate("/dashboard/analytics-dashboard")}
        className="bg-[#EDF4FF] rounded-2xl p-4 shadow-sm flex items-center justify-between cursor-pointer border border-[#D8E3F0]"
      >
        <div>
          <h4 className="text-[10px] font-bold text-[#4A90E2] uppercase">Training</h4>
          <p className="text-sm font-bold text-slate-900 mt-1">My Learnings</p>
        </div>
        <AcademicCapIcon className="w-5 h-5 text-[#4A90E2]" />
      </div>
    </div>
  </div>
</div>

{/* MY REQUESTS SECTION - For all employees */}
<div className="mt-6">
  <MyRequests />
</div>

{/* MANAGER TOOLS SECTION */}
{isManager && (
  <div className="mt-10 pt-8 border-t border-[#D8E3F0]/60">
    <div className="mb-6">
      <h2 className="text-sm font-bold text-slate-700 uppercase tracking-wider">Manager Tools</h2>
      <p className="text-xs text-slate-500 mt-1">Manage your team & approvals</p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <CompactTile
        title="Team Management"
        subtitle="Employees, performance & learning"
        iconColor="text-indigo-600"
        icon={<UsersIcon />}
        onClick={() => navigate("/manager/assign-training")}
      />
      <CompactTile
        title="Team Requests & Approvals"
        subtitle="Leaves, expenses & offboarding"
        iconColor="text-amber-600"
        icon={<ClockIcon />}
        onClick={() => navigate("/manager/requests")}
      />
    </div>
  </div>
)}

{/* HR/ADMIN SINGLE TILE */}
{isHROrAdmin && (
  <div className="mt-10 pt-8 border-t border-[#D8E3F0]/60">
    <div className="mb-6">
      <h2 className="text-sm font-bold text-slate-700 uppercase tracking-wider">
        {role === 'hr' ? 'HR Dashboard' : 'Admin Dashboard'}
      </h2>
      <p className="text-xs text-slate-500 mt-1">Access your operations center</p>
    </div>
    <div className="max-w-md">
      <CompactTile
        title={role === 'hr' ? 'HR Operations' : 'Admin Operations'}
        subtitle="Access all modules and tools"
        iconColor="text-blue-600"
        icon={<ShieldCheckIcon />}
        onClick={() => navigate('/admin')}
      />
    </div>
  </div>
)}

{/* TEAM LEAD PLACEHOLDER */}
{isTeamLead && (
  <div className="mt-10 pt-8 border-t border-[#D8E3F0]/60">
    <div className="mb-6">
      <h2 className="text-sm font-bold text-slate-700 uppercase tracking-wider">Team Lead Dashboard</h2>
      <p className="text-xs text-slate-500 mt-1">Coming soon - Team leadership tools</p>
    </div>
  </div>
)}

{/* FINANCE PLACEHOLDER */}
{isFinance && (
  <div className="mt-10 pt-8 border-t border-[#D8E3F0]/60">
    <div className="mb-6">
      <h2 className="text-sm font-bold text-slate-700 uppercase tracking-wider">Finance Dashboard</h2>
      <p className="text-xs text-slate-500 mt-1">Coming soon - Financial management tools</p>
    </div>
  </div>
)}

{/* TACTICAL PLACEHOLDER */}
{isTactical && (
  <div className="mt-10 pt-8 border-t border-[#D8E3F0]/60">
    <div className="mb-6">
      <h2 className="text-sm font-bold text-slate-700 uppercase tracking-wider">Tactical Dashboard</h2>
      <p className="text-xs text-slate-500 mt-1">Coming soon - Tactical operations tools</p>
    </div>
  </div>
)}

</div>

{/* MODALS */}
{(leaveModal || correctionModal) && (
<div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
<div className="bg-white rounded-2xl w-full max-w-md p-6 relative shadow-xl border border-[#D8E3F0]">
<button
onClick={() => {
setLeaveModal(false);
setCorrectionModal(false);
setLeaveValidationError("");
setLeaveReason("");
}}
className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"
>
<XMarkIcon className="w-6 h-6" />
</button>
<h3 className="text-xl font-bold text-slate-900 mb-6 font-['Poppins']">
{correctionModal ? "Correct Leaves" : "Request Leave"}
</h3>
{!leaveSuccess ? (
<div className="space-y-5">
<div>
<label className="text-xs font-bold text-slate-500 uppercase mb-2 block tracking-wider">Leave Type</label>
<select
value={leaveType}
onChange={e => setLeaveType(e.target.value)}
className="w-full border border-[#D8E3F0] rounded-lg py-3 px-4 text-sm outline-none focus:border-[#4A90E2] focus:ring-1 focus:ring-[#4A90E2]"
>
<option value="">Choose Type</option>
<option>Sick Leave</option>
<option>Casual Leave</option>
<option>Paid Leave</option>
</select>
</div>
<div className="grid grid-cols-2 gap-4">
<div>
<label className="text-xs font-bold text-slate-500 uppercase mb-2 block tracking-wider">From</label>
<input
type="date"
value={fromDate}
onChange={e => setFromDate(e.target.value)}
className="w-full border border-[#D8E3F0] rounded-lg py-3 px-4 text-sm outline-none focus:border-[#4A90E2] focus:ring-1 focus:ring-[#4A90E2]"
/>
</div>
<div>
<label className="text-xs font-bold text-slate-500 uppercase mb-2 block tracking-wider">To</label>
<input
type="date"
value={toDate}
onChange={e => setToDate(e.target.value)}
className="w-full border border-[#D8E3F0] rounded-lg py-3 px-4 text-sm outline-none focus:border-[#4A90E2] focus:ring-1 focus:ring-[#4A90E2]"
/>
</div>
</div>
<div>
<label className="text-xs font-bold text-slate-500 uppercase mb-2 block tracking-wider">Reason</label>
<textarea
value={leaveReason}
onChange={e => setLeaveReason(e.target.value)}
placeholder="Enter reason for leave request"
rows={3}
className="w-full border border-[#D8E3F0] rounded-lg py-3 px-4 text-sm outline-none focus:border-[#4A90E2] focus:ring-1 focus:ring-[#4A90E2] resize-none"
/>
</div>
{leaveValidationError && (
<p className="text-xs text-orange-600 bg-orange-50 p-3 rounded-lg border border-orange-100">{leaveValidationError}</p>
)}
<button
onClick={handleLeaveSubmit}
className="w-full bg-[#4A90E2] text-white py-3 rounded-lg font-bold text-sm hover:bg-[#1F6FB2] transition shadow-md active:scale-[0.98]"
>
{correctionModal ? "Submit Correction" : "Submit Request"}
</button>
</div>
) : (
<div className="text-center py-8">
<div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
<CheckCircleIcon className="w-10 h-10" />
</div>
<h4 className="text-lg font-bold text-slate-900 mb-2">Request Sent</h4>
<p className="text-sm text-slate-600">Processing your request...</p>
</div>
)}
</div>
</div>
)}

</main>
</div>
  );
}